import React, { useState } from 'react';
import { useHistory } from 'react-router';
import LoadingSpinner from '../../../Helpers/LoadingSpinner';
import steps from '../../../Config/StepsReclamoAccesoDigital';
import Wizard from '../../../Components/Common/Modules/Wizard';
import useObtenerMotivosReclamosOnRender from '../../../Hooks/useObtenerMotivosReclamosOnRender';
import FormRow from '../../../Components/Common/Atoms/Form/FormRow';
import FormCol from '../../../Components/Common/Atoms/Form/FormCol';
import Motivos from '../../../Components/Features/Motivos';
import Button from '../../../Components/Common/Modules/Button';
import PathsConfig from '../../../Config/RoutePaths';
import CallbackArticle from '../../../Components/Common/Modules/CallbackArticle';
import Suscripcion from '../../../Components/Features/ReclamoEntrega/Suscripcion';
import InfoSuscription from '../../../Components/Common/Atoms/InfoSuscription';
import InputGroup from '../../../Components/Common/Atoms/Form/InputGroup';
import ErrorGenerico from '../../../Components/Features/ErrorGenerico';

const ReclamoAccesoDigitalSuscriptor = (props) => {
    const { Id: IdSuscripcion, NombreAmigable } = props;
    const [motivosReclamo, errorMotivos, isLoadingMotivos] = useObtenerMotivosReclamosOnRender(IdSuscripcion);
    const [motivoSelected, setMotivoSelected] = useState(null);
    const [valMotivo, setValMotivo] = useState(null);
    const history = useHistory();
    const motivosReclamosFilter = motivosReclamo?.filter((item) => item.Id !== 58);

    const handleClickNextStep = (motivo) => {
        if (!motivo) {
            setValMotivo({ status: 'error', msg: 'Seleccioná un motivo de reclamo' });
        } else {
            history.push({
                pathname: PathsConfig.ReclamoAccesoDigitalPeriodo,
                state: {
                    IdSuscripcion,
                    motivoSelected: motivosReclamosFilter.find((m) => m.Id === Number(motivo)),
                    nombreSuscripcion: NombreAmigable,
                    suscripcion: props,
                },
            });
        }
    };

    const handleMotivoSelected = (value) => {
        if (isNaN(value)) {
            setMotivoSelected(null);
            setValMotivo({ status: 'error', msg: 'Seleccioná un motivo de reclamo' });
        } else {
            setMotivoSelected(value);
            setValMotivo(null);
        }
    };

    return (
        <section className="container-streched">
            <LoadingSpinner isLoading={isLoadingMotivos}>
                
                { errorMotivos ?
                    <ErrorGenerico />
                    : (
                    <>
                        <Wizard steps={steps} activeStep={1} />
                        <fieldset>
                            <InfoSuscription title="Suscripción a reclamar" suscripcion={props} />
                            <CallbackArticle
                                title="Seleccioná el motivo del reclamo"
                                description="Queremos solucionar tu problema, completá el siguiente formulario."
                            />
                            <FormRow>
                                <FormCol>
                                    {motivosReclamosFilter && motivosReclamosFilter.length > 0 && (
                                        <Motivos hasValidationError={valMotivo} motivos={motivosReclamosFilter} setMotivoSelected={handleMotivoSelected} />
                                    )}
                                </FormCol>
                            </FormRow>
                            <FormRow mod="--btn-groups">
                                <Button type="submit" tag="input" mod="state--mobile-w100" label="CONTINUAR RECLAMO" onClick={() => handleClickNextStep(motivoSelected)} />
                            </FormRow>
                        </fieldset>
                    </>
                    )
                }
            </LoadingSpinner>
        </section>
    );
};

export default ReclamoAccesoDigitalSuscriptor;
